// extracted by mini-css-extract-plugin
export var closeButton = "_m8-1";
export var closeX = "_m8-3";
export var container = "_m8-0";
export var image = "_m8-2";